import { Button } from '@cian/ui-kit';

import { type FC, type JSX, type SyntheticEvent, useCallback } from 'react';

import { ContactsButtonRenderer } from './CardContactsButtonRenderer';

export const CardContactsButtonMobileContainer: FC = () => {
  const renderButton = useCallback(
    ({ onClick, defaultText }: { onClick: (e: SyntheticEvent) => void; defaultText: string }): JSX.Element => (
      <Button fullWidth size="M" theme="fill_primary" onClick={onClick}>
        {defaultText}
      </Button>
    ),
    [],
  );

  return <ContactsButtonRenderer render={renderButton} />;
};
